const page = 'events';

export default [
    {
        path: '/core/' + page,
        name: `${page}-main`,
        exact: true,
        component: () => import('@/pages/core/events/Index'),
        meta: {
            auth: true,
            permission: ['core.events.access'],
            title: 'Events',
            prefix: `${page}-main`
        },
        children: [
            {
                path: `/core/events/event-statuses`,
                name: `${page}-events-type-status`,
                exact: true,
                component: () => import('@/pages/core/events/event_statuses/EventStatusesMain'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-type-status.access'],
                    title: 'Event Type Status',
                    prefix: `${page}-event-statuses`,
                },
            },
            {
                path: `/core/events/event-template-field-types`,
                name: `${page}-event-template-field-types`,
                exact: true,
                component: () => import('@/pages/core/events/event_template_field_types/EventTemplateFieldTypesMain'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates-field-types.access'],
                    title: 'Event Template Field Types',
                    prefix: `${page}-event-template-field-types`,
                },
            },
            {
                path: `/core/events/event-template-fields`,
                name: `${page}-event-template-fields`,
                exact: true,
                component: () => import('@/pages/core/events/event_template_fields/EventTemplateFieldsMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates-fields.access'],
                    title: 'Event Template Fields',
                    prefix: `${page}-event-template-fields`,
                },
            },
            {
                path: `/core/events/event-templates`,
                name: `${page}-event-templates`,
                exact: true,
                component: () => import('@/pages/core/events/event_templates/EventTemplatesMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-templates.access'],
                    title: 'Templates',
                    prefix: `${page}-event-templates`,
                },
            },
            {
                path: `/core/events/events-event-type-mappings`,
                name: `${page}-event-type-mappings`,
                exact: true,
                component: () => import('@/pages/core/events/event_type_mappings/EventTemplateMappingMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-type-mapping.access'],
                    title: 'Event Type Mappings',
                    prefix: `${page}-event-type-mappings`,
                },
            },
            {
                path: `/core/events/events-types`,
                name: `${page}-event-types`,
                exact: true,
                component: () => import('@/pages/core/events/event_types/EventTypeMain.vue'),
                meta: {
                    auth: true,
                    permission: ['core.events.event-type-mapping.access'],
                    title: 'Event Types', // todo
                    prefix: `${page}-event-typees`,
                },
            },

        ]
    },

];
